export default "__VITE_ASSET__d205b207__"